module.exports = __webpack_public_path__ + "img/zapier-logo.f70b23b4.png";